// extracted by mini-css-extract-plugin
export default {"main":"styles_main__5-Sb5","carts":"styles_carts__O-2SX","icon":"styles_icon__E-IpU","signSide":"styles_signSide__P2eA1","suitInfo":"styles_suitInfo__M6DMQ"};